'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (file, name) {
  var a = document.createElement('a');
  a.style = 'display: none';
  document.body.appendChild(a); //Create a DOMString representing the blob
  //and point the link element towards it
  // const url = window.URL.createObjectURL(file)

  var url = file;
  a.href = url;
  a.download = name;
  a.target = '_blank'; //programatically click the link to trigger the download

  a.click(); //release the reference to the file by revoking the Object URL

  window.URL.revokeObjectURL(url);
};